import React, { useEffect, useState } from "react";
import Header from "../../../component/organisms/header";
import MainLayout from "../../../component/atoms/layout/mainLayout";
import Sidebar from "../../../component/organisms/sidebar";
import DetailPageLayout from "../../../component/atoms/layout/detail/detailPageLayout";
import moment from "moment";
import { formatNumberWithCommas } from "./../../../util/formatNumber";
import GrayBtn from "../../../component/atoms/button/grayBtn";
import styled from "styled-components";
import PretendardText from "../../../component/atoms/text/pretendardText";
import MainInput from "./../../../component/atoms/input/mainInput";
import { useParams } from "react-router-dom";
import SelectBox from "../../../component/organisms/selectBox";
import GoBack from "../../../component/molecules/goBack";
import DetailTop from "../../../component/atoms/layout/detail/detailTop";
import DetailPage from "../../../component/atoms/layout/detail/detailPage";
import DetailPageTitle from "../../../component/atoms/text/detail/detailPageTitle";
import DetailPageForm from "./../../../component/atoms/layout/detail/detailPageForm";
import DetailFormTitle from "./../../../component/atoms/text/detail/detailFormTitle";
import DetailFormText from "./../../../component/atoms/text/detail/detailFormText";
import Checkbox from "./../../../component/atoms/input/checkbox";
import TextArea from "./../../../component/atoms/input/textarea";
import WritingLinkApi from "../../../api/writingLink.api";
import { errorHandler } from "../../../util/errorHandler";
import { toast } from "react-toastify";
import AlarmSendPopup from "../../../component/templates/user/userInfo/alarmSendPopup";
import SMSSendPopup from "../../../component/templates/user/userInfo/smsSendPopup";
import WLPointChange from "../../../component/organisms/writingLink/wlPointChange";
import { route } from "../../../router/route";

// TODO:
// - 초대 계정 포인트 변경, 초대 계정에 알림 보내기, 초대 계정에 SMS 보내기 작업 필요

const WritingLinkDetail = () => {
  let { id } = useParams();
  const [isWriteAuthority, setIsWriteAuthority] = useState(false);

  // ---------- 쓰기 권한체크 ---------- //
  useEffect(() => {
    const writeMenu = sessionStorage.getItem("writeMenu");

    if (writeMenu?.includes(route.crew_link)) {
      setIsWriteAuthority(true);
    } else {
      setIsWriteAuthority(false);
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // ---------- 마운트가 되면 ---------- //
  useEffect(() => {
    getWritingLinkDetail();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // ---------- 데이터 가져오기 ---------- //
  const [writingLinkDetail, setWritingLinkDetail] = useState({});

  const getWritingLinkDetail = async () => {
    try {
      const response = (await WritingLinkApi.getByIdHistory(id)).data.data
        .content;
      setWritingLinkDetail(response);
    } catch (error) {
      errorHandler(error);
    }
  };

  // ---------- 버튼 그룹 관련 ---------- //
  const [buttonGroupFilterOpen, setButtonGroupFilterOpen] = useState({
    pointChange: false, // 초대 계정 포인트 변경
    provideType: false, // 지급형태 변경
    provideStatus: false, // 지급상태 변경
  });

  // ---------- 지급형태 변경 관련 ---------- //
  const updateProvideType = async (cashFlag) => {
    try {
      const data = {
        activation: cashFlag,
      };

      await WritingLinkApi.updateCash(id, data);

      getWritingLinkDetail();

      setButtonGroupFilterOpen({
        pointChange: false,
        provideType: false,
        provideStatus: false,
      });
    } catch (error) {
      console.error(error);
    }
  };

  // ---------- 지급상태 변경 관련 ---------- //
  const updateDistributeStatus = async (distributeStatus) => {
    try {
      const data = {
        activation: distributeStatus,
      };

      await WritingLinkApi.updateDistribute(id, data);

      getWritingLinkDetail();

      setButtonGroupFilterOpen({
        pointChange: false,
        provideType: false,
        provideStatus: false,
      });
    } catch (error) {
      console.error(error);
    }
  };

  // ---------- 관리자 메모 ---------- //
  const updateMemo = async () => {
    try {
      const data = {
        memo: writingLinkDetail.memo,
      };

      await WritingLinkApi.updateMemo(id, data);

      toast("관리자 메모가 수정되었습니다.");

      getWritingLinkDetail();
    } catch (error) {
      console.error(error);
    }
  };

  const [alarmPopupOpen, setAlarmPopupOpen] = useState(false);
  const [smsPopupOpen, setSMSPopupOpen] = useState(false);

  return (
    <>
      <Header />
      <MainLayout
        style={{
          position: "relative",
          gap: 306,
        }}
      >
        <Sidebar />

        {/* 본문 영역 */}
        <DetailPageLayout>
          <DetailTop>
            <GoBack />
            {isWriteAuthority && (
              <div
                style={{
                  width: "fit-content",
                  display: "flex",
                  gap: 12,
                }}
              >
                <div
                  style={{
                    height: "fit-content",
                    display: "flex",
                    alignItems: "center",
                    cursor: "pointer",
                    position: "relative",
                  }}
                >
                  <GrayBtn
                    onClick={() => {
                      setButtonGroupFilterOpen({
                        pointChange: !buttonGroupFilterOpen.pointChange,
                        provideType: false,
                        provideStatus: false,
                      });
                    }}
                  >
                    초대 계정 포인트 변경
                  </GrayBtn>
                  {buttonGroupFilterOpen.pointChange && (
                    <WLPointChange
                      userCheckedIdList={[writingLinkDetail]}
                      getMemberList={getWritingLinkDetail}
                      sessionStorageInit={() => {}}
                      setButtonGroupOpen={() => {}}
                      setButtonGroupFilterOpen={setButtonGroupFilterOpen}
                    />
                  )}
                </div>
                <GrayBtn
                  onClick={() => {
                    setAlarmPopupOpen(true);
                  }}
                >
                  초대 계정에 알림 보내기
                </GrayBtn>
                <GrayBtn
                  onClick={() => {
                    setSMSPopupOpen(true);
                  }}
                >
                  초대 계정에 SMS 보내기
                </GrayBtn>
                <div
                  style={{
                    height: "fit-content",
                    display: "flex",
                    alignItems: "center",
                    cursor: "pointer",
                    position: "relative",
                  }}
                >
                  <GrayBtn
                    onClick={() => {
                      setButtonGroupFilterOpen({
                        pointChange: false,
                        provideType: !buttonGroupFilterOpen.provideType,
                        provideStatus: false,
                      });
                    }}
                  >
                    지급형태 변경
                  </GrayBtn>
                  {buttonGroupFilterOpen.provideType && (
                    <FilterWrapper
                      style={{
                        width: 115,
                        top: 36,
                      }}
                    >
                      <FilterTextWrapper>
                        <FilterText
                          onClick={() => {
                            updateProvideType(false);
                          }}
                        >
                          포인트
                          {!writingLinkDetail?.cashFlag && (
                            <img
                              src="/assets/admin/icons/ico_selectbox_checked.svg"
                              alt="포인트 선택됨"
                            />
                          )}
                        </FilterText>
                      </FilterTextWrapper>
                      <FilterText
                        onClick={() => {
                          updateProvideType(true);
                        }}
                      >
                        현금
                        {writingLinkDetail?.cashFlag && (
                          <img
                            src="/assets/admin/icons/ico_selectbox_checked.svg"
                            alt="현금 선택됨"
                          />
                        )}
                      </FilterText>
                    </FilterWrapper>
                  )}
                </div>
                <div
                  style={{
                    height: "fit-content",
                    display: "flex",
                    alignItems: "center",
                    cursor: "pointer",
                    position: "relative",
                  }}
                >
                  <GrayBtn
                    onClick={() => {
                      setButtonGroupFilterOpen({
                        pointChange: false,
                        provideType: false,
                        provideStatus: !buttonGroupFilterOpen.provideStatus,
                      });
                    }}
                  >
                    상태 변경
                  </GrayBtn>
                  {buttonGroupFilterOpen.provideStatus && (
                    <FilterWrapper
                      style={{
                        width: 115,
                        top: 36,
                      }}
                    >
                      <FilterTextWrapper>
                        <FilterText
                          onClick={() => {
                            updateDistributeStatus(true);
                          }}
                        >
                          지급완료
                          {writingLinkDetail?.distributeStatus && (
                            <img
                              src="/assets/admin/icons/ico_selectbox_checked.svg"
                              alt="지급완료 선택됨"
                            />
                          )}
                        </FilterText>
                      </FilterTextWrapper>
                      <FilterText
                        onClick={() => {
                          updateDistributeStatus(false);
                        }}
                      >
                        미지급
                        {!writingLinkDetail?.distributeStatus && (
                          <img
                            src="/assets/admin/icons/ico_selectbox_checked.svg"
                            alt="미지급 선택됨"
                          />
                        )}
                      </FilterText>
                    </FilterWrapper>
                  )}
                </div>
              </div>
            )}
          </DetailTop>
          <DetailPage
            style={{
              minHeight: "556px",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                marginBottom: 30,
              }}
            >
              <DetailPageTitle
                style={{
                  marginBottom: 12,
                }}
              >
                리이팅링크로 유입된 계정
              </DetailPageTitle>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <DetailPageForm
                  style={{
                    gap: 32,
                    height: 46,
                  }}
                >
                  <DetailFormTitle
                    style={{
                      minWidth: 140,
                    }}
                  >
                    라이팅링크로 유입된 계정
                  </DetailFormTitle>
                  <DetailFormText>
                    {writingLinkDetail?.recipientName || ""}(
                    {writingLinkDetail?.recipientEmail || ""})
                  </DetailFormText>
                </DetailPageForm>
                <DetailPageForm
                  style={{
                    gap: 32,
                    height: 46,
                  }}
                >
                  <DetailFormTitle
                    style={{
                      minWidth: 140,
                    }}
                  >
                    초대한 계정
                  </DetailFormTitle>
                  <DetailFormText>
                    {writingLinkDetail?.senderName || ""}(
                    {writingLinkDetail?.senderEmail || ""})
                  </DetailFormText>
                </DetailPageForm>
                <DetailPageForm
                  style={{
                    gap: 32,
                    height: 46,
                  }}
                >
                  <DetailFormTitle
                    style={{
                      minWidth: 140,
                    }}
                  >
                    유입일
                  </DetailFormTitle>
                  <DetailFormText>
                    {moment(writingLinkDetail.createdAt).format("YYYY-MM-DD")}
                  </DetailFormText>
                </DetailPageForm>
                <DetailPageForm
                  style={{
                    gap: 32,
                    height: 46,
                  }}
                >
                  <DetailFormTitle
                    style={{
                      minWidth: 140,
                    }}
                  >
                    지급 형태
                  </DetailFormTitle>
                  <DetailFormText>
                    {writingLinkDetail?.cashFlag ? "현금" : "포인트"}
                  </DetailFormText>
                </DetailPageForm>
                <DetailPageForm
                  style={{
                    gap: 32,
                    height: 46,
                  }}
                >
                  <DetailFormTitle
                    style={{
                      minWidth: 140,
                    }}
                  >
                    지급 금액
                  </DetailFormTitle>
                  <DetailFormText>
                    {formatNumberWithCommas(writingLinkDetail?.amount || 0)}
                    {writingLinkDetail?.cashFlag ? "원" : "P"}
                  </DetailFormText>
                </DetailPageForm>
                <DetailPageForm
                  style={{
                    gap: 32,
                    height: 46,
                  }}
                >
                  <DetailFormTitle
                    style={{
                      minWidth: 140,
                    }}
                  >
                    상태
                  </DetailFormTitle>
                  <DetailFormText
                    style={{
                      color: writingLinkDetail.distributeStatus
                        ? "#aaa"
                        : "#cf6679",
                    }}
                  >
                    {writingLinkDetail.distributeStatus ? "지급완료" : "미지급"}
                  </DetailFormText>
                </DetailPageForm>
              </div>
            </div>
            {/* 관리자 메모 */}
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                marginBottom: 40,
              }}
            >
              <DetailPageTitle>관리자 메모</DetailPageTitle>
              <div
                style={{
                  width: "100%",
                  position: "relative",
                  height: "fit-content",
                }}
              >
                <TextArea
                  type={"text"}
                  placeholder={"내용을 입력해주세요 (최대 500자)"}
                  value={writingLinkDetail?.memo || ""}
                  onChange={(e) => {
                    setWritingLinkDetail({
                      ...writingLinkDetail,
                      memo: e.target.value,
                    });
                  }}
                  maxLength={500}
                  style={{
                    width: "1044px",
                    minHeight: "104px",
                  }}
                />
                {isWriteAuthority && (
                  <GrayBtn
                    style={{
                      backgroundColor: "#313233",
                      position: "absolute",
                      right: 15,
                      bottom: 15,
                    }}
                    onClick={updateMemo}
                  >
                    등록
                  </GrayBtn>
                )}
              </div>
            </div>
          </DetailPage>
        </DetailPageLayout>
      </MainLayout>

      {/* 알림 보내기 */}
      {alarmPopupOpen && (
        <AlarmSendPopup
          setPopupOpen={setAlarmPopupOpen}
          userCheckedIdList={[
            {
              id: writingLinkDetail?.id,
              email: writingLinkDetail?.senderEmail,
            },
          ]}
          getMemberList={getWritingLinkDetail}
          sessionStorageInit={() => {}}
          setButtonGroupOpen={() => {}}
        />
      )}

      {/* SMS 보내기 */}
      {smsPopupOpen && (
        <SMSSendPopup
          setPopupOpen={setSMSPopupOpen}
          userCheckedIdList={[
            {
              phoneNumber: writingLinkDetail?.senderPhoneNumber,
            },
          ]}
          getMemberList={getWritingLinkDetail}
          sessionStorageInit={() => {}}
          setButtonGroupOpen={() => {}}
        />
      )}
    </>
  );
};

export default WritingLinkDetail;

const FilterWrapper = styled.div.attrs((props) => {})`
  padding: 10px;
  border-radius: 3px;
  background: #272829;
  box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.25);
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 48px;
  z-index: 5;
`;

const FilterTextWrapper = styled.div.attrs((props) => {})`
  display: flex;
  gap: 1px;
`;

const FilterText = styled(PretendardText).attrs((props) => {})`
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 10px;
  color: #aaa;
  font-size: 15px;
  font-weight: 500;
  line-height: 22px;
  border-radius: 3px;
  cursor: pointer;

  &:hover {
    background: #313233;
  }
`;

const CheckboxWrapper = styled.div.attrs((props) => {})`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const CheckboxText = styled(PretendardText).attrs((props) => {})`
  font-size: 15px;
  font-weight: 500;
  line-height: 21.5px;
  color: #aaa;
`;
